// extracted by mini-css-extract-plugin
export var alt = "FAQAutocomplete-module--alt--270f4";
export var container = "FAQAutocomplete-module--container--f89e6";
export var desktopOnly = "FAQAutocomplete-module--desktopOnly--3c005";
export var inputWrapper = "FAQAutocomplete-module--inputWrapper--2b365";
export var main = "FAQAutocomplete-module--main--1755a";
export var mobileOnly = "FAQAutocomplete-module--mobileOnly--28cf4";
export var noSuggestionsDiv = "FAQAutocomplete-module--noSuggestionsDiv--8551a";
export var searchResult = "FAQAutocomplete-module--searchResult--11e2c";
export var sectionContainer = "FAQAutocomplete-module--sectionContainer--6c967";
export var textLeft = "FAQAutocomplete-module--textLeft--e91ae";
export var visuallyHidden = "FAQAutocomplete-module--visuallyHidden--304cd";